// components/MultiStepForm/FormField.tsx
import styles from './FormField.module.css'

interface FormFieldProps {
  label: string
  error?: string
  required?: boolean
  children: React.ReactNode
}

export const FormField = ({ label, error, required, children }: FormFieldProps) => {
  return (
    <div className={styles.Container}>
      <label className={styles.Label} htmlFor={label}>
        {label}
        {required && <span className={styles.Required}>*</span>}
      </label>
      {children}
      {error && <span className={styles.Error}>{error}</span>}
    </div>
  )
}
